<template>
  <div class="dashbord" style="overflow-y:hidden;overflow-x:hidden;height:auto">
    <div class="searchBar">
      <!-- <el-date-picker style="margin-right:20px"
			size="small"
			class="dataRange"
			v-model="dateRange"
			type="daterange"
			range-separator="至"
			start-placeholder="开始时间"
			end-placeholder="结束时间"
			value-format="yyyy-MM-dd"
			:clearable="false"
			@change="dateChange($event)">
		></el-date-picker> -->
      <el-date-picker
        :editable="false"
        type="date"
        placeholder="选择开始日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        v-model="searchForm.startDate"
        style="width: 180px;"
        @change="startChange($event)"
      >
      </el-date-picker>
      &nbsp
      <el-date-picker
        :editable="false"
        type="date"
        :default-value="searchForm.defaultEnd"
        placeholder="选择结束日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        v-model="searchForm.endDate"
        :picker-options="endOption"
        style="width: 180px;"
        @change="endChange($event)"
      >
      </el-date-picker>
      &nbsp&nbsp
      <el-button size="mini" type="primary" icon="el-icon-search" @click="clickSearch()">查询</el-button>
      <span style="font-size:14px;color:#626266;margin-left:20px;">注：仅可查询从开始日期起一周内的数据</span>
    </div>

    <div class="panel" style="grid-area:a">
      停机总时长
      <div id="stopTime">
        <div class="numP">{{ Math.round((stopTime % 10000) / 1000) }}</div>
        <div class="numP">{{ Math.round((stopTime % 1000) / 100) }}</div>
        <div class="numP">{{ Math.round((stopTime % 100) / 10) }}</div>
        <div class="numP">{{ Math.round(stopTime % 10) }}</div>
      </div>
      <div style="position: absolute; color: #303133;font-weight: 100;right: 20px;top: 120px;">小时</div>
    </div>
    <div class="panel" style="grid-area:b">
      <div>设备故障率</div>
      <div class="circle">
        <el-progress type="circle" :percentage="failureRate" color="#409EFF" :stroke-width="8"></el-progress>
      </div>
    </div>
    <div class="panel" style="grid-area:c">
      <div>计划稼动率</div>
      <div class="circle">
        <el-progress type="circle" :percentage="planOperationRate" color="#E86067" :stroke-width="8"></el-progress>
      </div>
    </div>
    <div class="panel" style="grid-area:d">
      <div>性能/实际稼动率</div>
      <div class="circle">
        <el-progress type="circle" :percentage="actualOperationRate" color="#FFBE00" :stroke-width="8"></el-progress>
      </div>
    </div>
    <div class="panel" style="grid-area:o">
      <div ref="deviceOEELineStatic" style="width: 100%;height:100%;position:absolute"></div>
      <div v-if="deviceOEEViewData.x.length == 0" class="noData"><img src="/static/img/noData.png" /></div>
      <el-scrollbar style="height:100%;">
        <div ref="deviceOEELine" style="width: 100%;" :style="{ height: deviceOEEViewHeight + 'px' }" v-if="hasDeviceOEEViewData"></div>
      </el-scrollbar>
    </div>
    <div class="panel" style="grid-area:z">
      <div v-if="!deviceStatusBlockData" class="noData"><img src="/static/img/noData.png" /></div>
      <div ref="deviceStatusViewStatic" style="width: 100%;height:100%;position:absolute"></div>
      <el-scrollbar style="width:70%;height:100%;">
        <div ref="deviceStatusView" style="width: 100%;" :style="{ height: deviceStatusViewHeight + 'px' }" v-if="hasDeviceStatusBlockData"></div>
      </el-scrollbar>
    </div>

    <!-- <div id="workShopGlobalChart" style="overflow-y:auto;margin-right:-11px">
		<div ref="deviceStatusPieDiv" style="height: 300px;" v-if="false"></div>
		<div style="height: 360px;margin-top: 0px;margin-left: 0px;">
			<el-scrollbar class="chartDiv" style="margin-bottom: 20px;"
				wrap-style="height:360px;overflow-x: hidden;margin-bottom: 0;">
				<el-row style="position: absolute;width: 100%;top: 30px;left: 300px;z-index: 10;">
							<el-date-picker
												:editable="false"
												type="date"
												placeholder="选择开始日期"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												v-model="searchForm.startDate"
							
												style="width: 180px;"
												@change="startChange($event,1)">
										</el-date-picker>
						<el-date-picker
												:editable="false"
												type="date"
							:default-value="searchForm.defaultEnd"
												placeholder="选择结束日期"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												v-model="searchForm.endDate"
							:picker-options="endOption"
												style="width: 180px;"
												@change="endChange($event,2)">
										</el-date-picker>
									<el-button type="primary" @click="clickSearch">查询</el-button>
						<span>注:仅可查询从开始日期起一周内的数据</span>
				</el-row>
				<el-row class="oee_echart_div" style="width: 100%;">
					<div style="width: 100%;" :style="{height: deviceOEEViewHeight + 'px'}" v-if="hasDeviceOEEViewData">
						<div ref="deviceOEELine" style="float:left;width: 80%;" :style="{height: deviceOEEViewHeight + 'px'}">

						</div>
						<div style="float:left;width: 20%;height:235px;margin-top:80px;">
							加工零件数
							<ul style="height:100%;overflow-y:scroll;">
								<li v-for="(item,index) in partStat" :key="index" style="line-height:2;max-width:200px;">
									{{item.deviceCode}}:{{item.partCount}}个
								</li>
							</ul>
						</div>
					</div>
					<div v-else>
						<div class="echart_title">设备综合效率(OEE)曲线</div>
						<div class="echart_no_data">暂无数据</div>
					</div>
				</el-row>
			</el-scrollbar>
			<el-scrollbar class="chartDiv"
				wrap-style="height:430px;overflow-x: hidden;margin-bottom: 0;">
				<el-row style="position: absolute;width: 100%;top: 30px;left: 300px;z-index: 10;">
	    			<el-date-picker
	                    :editable="false"
	                    type="date"
	                    placeholder="选择开始日期"
	                    format="yyyy 年 MM 月 dd 日"
	                    value-format="yyyy-MM-dd"
	                    v-model="searchForm.deviceStartDate"

	                    style="width: 180px;"
	                    @change="startChange($event,2)">
	                </el-date-picker>
					<el-date-picker
	                    :editable="false"
						:default-value="searchForm.defaultDeviceEnd"
	                    type="date"
	                    placeholder="选择结束日期"
	                    format="yyyy 年 MM 月 dd 日"
	                    value-format="yyyy-MM-dd"
	                    v-model="searchForm.deviceEndDate"
						:picker-options="deviceEndOption"
	                    style="width: 180px;"
	                    @change="endChange($event,2)">
	                </el-date-picker>
		            <el-button type="primary" @click="searchDevice">查询</el-button>
					<span>注:仅可查询从开始日期起一周内的数据</span>
				</el-row>
				<el-row class="block_echart_div">
					<div ref="deviceStatusView" 
						:style="{height: deviceStatusViewHeight + 'px',width: windowWidth+'px'}" 
						 v-if="hasDeviceStatusBlockData">
					</div>
					<div v-else>
						<div class="echart_title">设备状态分布</div>
						<div class="echart_no_data"><span>暂无数据</span></div>
					</div>
				</el-row>
			</el-scrollbar>
		</div>
	</div> -->
  </div>
</template>

<script>
import commom from "../../util/CommonUtils";
// import statusData from './Untitled-1.json'

// let oeeChart = this.$Echarts(document.getElementById("oee")
let statusMapping = {
  0: "离线",
  10: "就绪",
  20: "运行",
  30: "停止",
  40: "报警停止"
};

export default {
  name: "workShopGlobalChart",
  data() {
    let vue = this;
    return {
      noOEEData: false,
      noStatusData: false,
      dateRange: [],
      deviceStartOption: {
        disabledDate(time) {
          if (time.getTime() > new Date().getTime()) {
            return true;
          }
          if (vue.searchForm.deviceEndDate) {
            return time.getTime() < new Date(vue.searchForm.deviceEndDate).getTime() - 7 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(vue.searchForm.deviceEndDate).getTime();
          } else {
            return false;
          }
        }
      },
      endOption: {
        disabledDate(time) {
          if (time.getTime() > new Date().getTime()) {
            return true;
          }
          if (vue.searchForm.startDate) {
            return time.getTime() > new Date(vue.searchForm.startDate).getTime() + 6 * 24 * 60 * 60 * 1000 || time.getTime() < new Date(vue.searchForm.startDate).getTime() - 24 * 60 * 60 * 1000;
          } else {
            return false;
          }
        }
      },
      startOption: {
        disabledDate(time) {
          if (time.getTime() > new Date().getTime()) {
            return true;
          }
          if (vue.searchForm.endDate) {
            return time.getTime() < new Date(vue.searchForm.endDate).getTime() - 7 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(vue.searchForm.endDate).getTime();
          } else {
            return false;
          }
        }
      },
      workshopId: null,
      searchForm: {
        startDate: "",
        endDate: "",
        deviceStartDate: "",
        deviceEndDate: "",
        defaultDeviceEnd: "",
        defaultEnd: ""
      },
      deviceStatusPie: null,
      deviceStatusBlockChart: null,
      deviceStatusBlockStaitcChart: null,
      windowWidth: 1520,
      deviceStatusViewHeight: 0, //设备状态分段图高度，根据设备数计算
      deviceStatusBlockData: null,

      deviceStatusBlockChange: false,
      totalDataViewWidth: 700, //width: 150%
      deviceOEEChart: null,
      deviceOEEStaticChart: null,

      deviceOEEViewHeight: 0, //设备OEE统计图高度
      deviceOEEViewData: { x: [], y: [], count: [] },
      partStat: null,
      deviceOEEViewChange: false,
      count: 1,
      stopTime: 0,
      failureRate: 0,
      planOperationRate: 0,
      actualOperationRate: 0,
      W: false
    };
  },
  //el和data尚未初始化
  beforeCreate: function() {},
  //data初始化完成
  created: function() {},
  //el初始化完成
  beforeMount: function() {
    let clientWidth = document.body.clientWidth;
    if (clientWidth <= 1400) {
      this.windowWidth = 1520;
    }
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  //完成挂载
  mounted: function() {
    this.initDeviceOEELineStatic();
    this.initDeviceStatusViewStatic();
    if (this.workshopId == null) {
      let workshopId = this.$route.query.workshopId;
      if (workshopId != null) {
        this.initDate();
        this.$nextTick(async () => {
          this.workshopId = workshopId;
          await this.loadDeviceOEEData();
          await this.loadDeviceStatusBlock();
        });
      }
    }
  },
  //更新dom前触发
  beforeUpdate: function() {},
  updated: function() {
    if (this.deviceStatusBlockChange) {
      // this.initDeviceStatusView(this.deviceStatusBlockData);
    }
    if (this.deviceOEEViewChange) {
      // this.initDeviceOEELine(this.deviceOEEViewData);
    }
    /*if(this.isShow && this.data != null){
			this.initEchart(this.data);
		}*/
  },
  //激活tab页时
  activated() {
    if (this.workshopId == null) {
      let workshopId = this.$route.query.workshopId;
      if (workshopId != null) {
        this.workshopId = workshopId;
      }
    }
  },
  deactivated() {},
  beforeDestroy: function() {},
  destroyed: function() {},
  components: {},
  computed: {
    showCharts() {
      return this.isShow;
    },
    hasDeviceOEEViewData() {
      let flag = false;
      if (this.deviceOEEViewData != null && this.deviceOEEViewData.x.length > 0) {
        flag = true;
      }
      return flag;
    },
    hasDeviceStatusBlockData() {
      let flag = false;
      if (this.deviceStatusBlockData != null && this.deviceStatusBlockData.devices.length > 0) {
        flag = true;
      }
      return flag;
    },
    //设备状态饼图数据
    statusRatioData() {
      let statusCodeArr = [0, 10, 20, 30, 40];
      let data = this.deviceStatusBlockData;
      if (data != null && data.statusTotalTime != null) {
        return Object.keys(data.statusTotalTime).map(index => {
          let item = [];
          let e = data.statusTotalTime[index];
          for (let key in statusMapping) {
            if (e[key] !== undefined) {
              item.push({ name: statusMapping[key], value: e[key].toFixed(1), deviceCode: data.deviceCodes[index] });
            } else {
              item.push({ name: statusMapping[key], value: 0 });
            }
          }
          return item;
        });
      } else {
        return [];
      }
    },
    // 设备状态饼图数据图例数据
    statusRatioLableData() {
      // data: [
      //         		{value: [0, 3, 4]},
      //         		{value: [10, 3, 4]},
      //         		{value: [20, 3, 4]},
      //         		{value: [30, 3, 4]},
      //         		{value: [40, 3, 4]},
      //         	]
      let data = this.deviceStatusBlockData;
      let deviceStopTime = 0;
      if (data != null && data.statusTotalTime != null) {
        let result = Object.keys(data.statusTotalTime).map(index => {
          let item = [];
          let e = data.statusTotalTime[index];
          for (let key in statusMapping) {
            if (e[key] !== undefined) {
              item.push({ status: key, value: Number(e[key].toFixed(1)) });
              if (key == 30 || key == 40) {
                deviceStopTime += Number(e[key].toFixed(1));
              }
            } else {
              item.push({ status: key, value: 0 });
            }
          }

          let totalTime = item.reduce((a, b) => {
            return { value: a.value + b.value };
          }).value;
          return item.map(e => {
            return { value: [e.status, e.value, ((e.value / totalTime) * 100).toFixed(2)] };
          });
        });
        this.stopTime = deviceStopTime;
        return result;
      } else {
        return [];
      }
    }
  },
  methods: {
    initDate() {
      let now = commom.timestampToDate(new Date().getTime(), true);
      this.searchForm.startDate = now;
      this.searchForm.endDate = now;
      this.searchForm.deviceStartDate = now;
      this.searchForm.deviceEndDate = now;
    },

    disabledEndtime(val) {
      console.log("aaaaa", val);
      return false;
    },
    close() {
      this.clearPie();
      this.$emit("update:isShow", false);
    },
    async getDashbordData() {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/workshop/workShopDashBord",
        type: "sync",
        params: {
          workshopId: this.workshopId,
          startTime: this.searchForm.startDate,
          endTime: this.searchForm.endDate
        }
      });
      if (res.code == 0) {
        // this.stopTime = res.data.stopTime;
        this.failureRate = Number(res.data.failureRate.toFixed(2));
        this.planOperationRate = Number((res.data.planOperationRate * 100).toFixed(2));
        this.actualOperationRate = Number(res.data.actualOperationRate.toFixed(2));
      }
    },
    //显示设备运行状态图表
    initEchart(realtimeData) {
      let onlineGroup = [];
      let offlineGroup = [];
      let allDeviceCount = realtimeData.count;
      for (var i = 0; i < realtimeData.result.length; i++) {
        if (realtimeData.result[i].cncstatusinfoCncstatus != 0) {
          onlineGroup.push(realtimeData.result[i]);
        } else {
          offlineGroup.push(realtimeData.result[i]);
        }
      }

      var statistics = [];
      if (allDeviceCount > 0) {
        var onlineGroupData = {};
        onlineGroupData.value = onlineGroup.length;
        onlineGroupData.name = "开机";
        statistics.push(onlineGroupData);

        if (allDeviceCount - onlineGroup.length > 0) {
          var offlineGroupData = {};
          offlineGroupData.value = allDeviceCount - onlineGroup.length;
          offlineGroupData.name = "关机";
          statistics.push(offlineGroupData);
        }
      }

      let option = {
        //color: ['#32b16c','#32b16c'],
        title: {
          text: "机组状态汇总"
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },
        series: [
          {
            type: "pie",
            radius: [100, 60],
            hoverAnimation: false,
            label: {
              position: "inside",
              formatter: "{b}\n{c}"
            },
            data: statistics
          }
        ]
      };
      if (this.deviceStatusPie == null) {
        this.deviceStatusPie = this.$Echarts.init(this.$refs["deviceStatusPieDiv"]);
      }
      this.deviceStatusPie.setOption(option);
    },
    clearPie() {
      if (this.deviceStatusPie != null) {
        this.deviceStatusPie.clear();
      }
    },
    async clickSearch() {
      await this.getDashbordData();
      await this.loadDeviceOEEData();
      await this.loadDeviceStatusBlock();
    },
    searchDevice() {
      this.loadDeviceStatusBlock();
    },
    async loadDeviceOEEData() {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/workshop/listWorkshopOeeOverview",
        type: "sync",
        params: {
          workshopId: this.workshopId,
          begin: this.searchForm.startDate,
          end: this.searchForm.endDate
        }
      });
      if (res.code != 0) {
        this.$message.error("未获取到OEE数据");
        return;
      }
      if (res.result.length == 0) {
        this.$message.warning("查询不到符合条件的数据");
      }
      let data = { x: [], y: [], count: [] };
      this.partStat = [];
      res.result.forEach((val, index) => {
        let partInfo = {};
        partInfo.deviceCode = val.deviceCode;
        partInfo.partCount = val.partCount;
        this.partStat.push(partInfo);
        if (val.deviceCode != null) {
          data.x.push(val.deviceCode);
        } else {
          data.x.push(val.deviceName);
        }
        let oee = val.oeeRatio;
        if (oee == "Infinity") {
          oee = 1.0;
        }

        data.y.push(parseInt(Math.round(oee * 1000)) / 10);
        data.count.push(val.partCount);
      });
      this.deviceOEEViewHeight = 50 * data.x.length + 115;
      this.deviceOEEViewData = data;
      this.initDeviceOEELine(data);
    },
    async loadDeviceStatusBlock() {
      /*
			setTimeout((res) => {
				let str = '{"code":0,"data":{"data":[{"deviceIndex":0,"statusType":40,"beginDate":"2018-12-06 00:00","endDate":"2018-12-07 12:46"},{"deviceIndex":0,"statusType":0,"beginDate":"2018-12-07 12:46","endDate":"2018-12-07 13:37"},{"deviceIndex":0,"statusType":40,"beginDate":"2018-12-07 13:37","endDate":"2018-12-07 13:38"},{"deviceIndex":1,"statusType":40,"beginDate":"2018-12-06 00:00","endDate":"2018-12-07 12:46"}],"devices":["4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F","4D9B52E40ABD65956E963789B987261F"],"statusTotalTime":{"0":{"0":0.85,"40":36.790000000000006}}},"message":"调用成功"}';
				res = JSON.parse(str);
				console.log(res);
				let height = 40 * res.data.devices.length + 110;
				this.deviceStatusViewHeight = height;
				this.deviceStatusBlockData = res.data;
			}, 100);*/
      let params = {};
      if (this.searchForm.startDate && this.searchForm.endDate) {
        params = {
          workshopId: this.workshopId,
          beginTime: this.searchForm.startDate,
          endTime: this.searchForm.endDate
        };
      } else {
        params = {
          workshopId: this.workshopId
        };
      }
      let res = await this.$RequestUtil.getAsync({
        url: "/api/workshop/getDeviceStatusBlock",
        type: "sync",
        params
        // success: (res) => {

        // }
      });
      // let res  = statusData;
      if (res.code != 0) {
        if (res.code == 2 || res.code == -1) {
          this.$message.warning("查询不到符合条件的数据");
          let height = 150;
          this.deviceStatusViewHeight = height;
          this.deviceStatusBlockData = null;
        }
        if (res.code == 1) {
          this.$message.error("获取数据失败，请稍后重试!");
          return;
        }
      } else {
        if (res.data) {
          let height = 40 * res.data.devices.length + 150;
          this.deviceStatusViewHeight = height;
          this.deviceStatusBlockData = res.data;
        }
      }
      this.initDeviceStatusView(this.deviceStatusBlockData);
    },
    //初始化设备OEE折线图
    initDeviceOEELineStatic() {
      this.deviceOEEStaticChart = this.$Echarts.init(this.$refs["deviceOEELineStatic"]);
      let option = {
        title: [
          {
            text: "设备综合效率(OEE)",
            textStyle: {
              color: "#434343",
              fontFamily: "PingFangSC-Medium",
              fontSize: "16"
            }
          },
          {
            text: "加工零件数",
            left: "70%",
            textStyle: {
              color: "#434343",
              fontFamily: "PingFangSC-Medium",
              fontSize: "16"
            }
          }
        ]
      };
      this.deviceOEEStaticChart.setOption(option);
    },
    initDeviceOEELine(data) {
      if (this.deviceOEEChart != null) {
        this.deviceOEEChart.clear();
        this.deviceOEEChart.resize();
      }
      // 计算平均值
      let average = 60;
      let total = 0;
      let valueArr = data.y;
      for (let i = valueArr.length; i--; ) {
        total += valueArr[i];
      }
      // 是否显示平均值辅助线
      let averageMarkLine = null;
      /*if(valueArr.length > 1){
                average = parseInt(total/valueArr.length);*/
      average = parseInt(total / valueArr.length);
      averageMarkLine = {
        symbol: "none",
        data: [
          {
            name: "平均线",
            type: "average",
            valueIndex: 0, //x轴
            lineStyle: {
              color: "#dedfe6",
              width: 1,
              type: "dashed"
            },
            label: {
              position: "start",
              formatter: "平均值{c}",
              fontSize: "14",
              fontFamily: "PingFangSC-Regular",
              color: "#999999"
            }
          }
        ]
      };
      /*}*/
      if (this.$refs["deviceOEELine"] == null) {
        return;
      }
      this.deviceOEEChart = this.$Echarts.init(this.$refs["deviceOEELine"]);
      // data={x:['VG-S0860610046','b','c','d','e','f'],y:[98,22,19,13,55,73],count:[11,35,98,13,55,27]}
      let option = {
        // title: [{
        // 	text: "设备综合效率(OEE)",
        // 	textStyle: {
        //           color: "#434343",
        // 		fontFamily: "PingFangSC-Medium",
        // 		fontSize: "16",
        //       }
        // },{
        // 	text:"加工零件数",
        // 	left:'70%',
        // 	textStyle: {
        // 		color: "#434343",
        // 		fontFamily: "PingFangSC-Medium",
        // 		fontSize: "16",
        // 	}
        // }],
        // dataZoom:{
        // 	type:'slider',
        // 	show : true,
        // 	yAxisIndex:[0,1],
        // 	left:'65%',
        // 	showDetail:false,
        // 	showDataShadow:false,
        // 	// width:10,
        // 	startValue:0,
        // 	endValue:3,
        // },
        grid: [
          {
            id: "left",
            left: "40",
            right: "40%",
            top: "50",
            bottom: "20",
            containLabel: true,
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow"
              }
            }
          },
          {
            id: "right",
            left: "70%",
            top: "50",
            bottom: "20",
            containLabel: true
          }
        ],
        xAxis: [
          {
            gridIndex: 0,
            type: "value",
            max: 120,
            axisLine: {
              lineStyle: {
                color: "#e7e7ec",
                type: "solid",
                width: 1
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          },
          {
            gridIndex: 1,
            type: "value",
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            gridIndex: 0,
            type: "category",
            data: data.x,
            inverse: true,
            max: data.x.length - 1,
            axisLabel: {
              formatter: function(val, index) {
                return val;
              },
              color: "#666666",
              fontFamily: "PingFangSC-Regular",
              fontSize: "14"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#bbbbbb"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          },
          {
            gridIndex: 1,
            type: "category",
            inverse: true,
            data: data.x,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: data.y,
            type: "bar",
            barWidth: "20",
            itemStyle: {
              normal: {
                color: function(item) {
                  let color = "#409EFF";
                  // 小于平均值，显示紫色
                  if (average != null && item.value < average) {
                    color = "#E86067";
                  }
                  return color;
                },
                lineStyle: {
                  color: "blue"
                }
              }
            },
            label: {
              normal: {
                show: true,
                position: "right",
                color: "#626366",
                fontSize: "14px",
                fontFamily: "PingFangSC-Regular",
                formatter: "{c}%"
              }
            }
          },
          {
            type: "bar",
            yAxisIndex: 1,
            xAxisIndex: 1,
            data: data.count,
            barWidth: "14",
            color: "#9AD681",
            itemStyle: {
              barBorderRadius: 7
            },
            label: {
              show: true,
              color: "#626366",
              position: "right",
              formatter: "{c}个"
            }
          }
        ]
      };
      // 追加平均值辅助线
      if (averageMarkLine != null) {
        option.series[0].markLine = averageMarkLine;
      }
      this.deviceOEEChart.setOption(option);
      this.deviceOEEViewChange = false;
    },
    initDeviceStatusViewStatic() {
      this.deviceStatusBlockStaitcChart = this.$Echarts.init(this.$refs["deviceStatusViewStatic"]);
      let colors = ["#A4A8AF", "#FFBE00", "#9AD681", "#409EFF", "#E86067"];
      let colorMapping = {
        0: colors[0],
        10: colors[1],
        20: colors[2],
        30: colors[3],
        40: colors[4]
      };
      let option = {
        color: colors,
        title: {
          text: "设备状态分布",
          textStyle: {
            color: "#434343",
            fontFamily: "PingFangSC-Medium",
            fontSize: "16"
          }
        },
        legend: {
          //图例
          data: ["离线", "就绪", "运行", "停止", "报警停止"],
          top: "20",
          right: "40%",
          icon: "rect",
          itemWidth: 14,
          selectedMode: false, // 图例设为不可点击
          textStyle: {
            fontFamily: "PingFangSC-Regular",
            fontSize: "14"
          }
        },
        grid: [
          {
            left: "85%",
            right: "0",
            top: "70",
            bottom: "0",
            containLabel: true
          }
        ],
        xAxis: {
          type: "value",
          position: "top",
          data: [1, 2, 3],
          max: 3,
          interval: 1,
          axisLine: {
            lineStyle: {
              color: "#e7e7ec",
              type: "solid",
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          inverse: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: "pie",
            name: "pie",
            left: "75%",
            top: 146,
            minAngle: 5,
            center: ["10%", "10%"],
            radius: ["70", "90"],
            label: {
              position: "center",
              formatter: params => {
                if (params.dataIndex == 0) {
                  if (params.data.deviceCode == undefined) {
                    return "暂无数据";
                  }
                  return "设备编号\n" + params.data.deviceCode;
                }
                return "";
              },
              color: "#333333"
            },
            itemStyle: {
              borderWidth: 3,
              borderColor: "#fff"
            },
            data: [0, 0, 0, 0, 0],
            tooltip: {
              formatter: "{b} {c}h {d}%"
            }
          },
          {
            name: "pieLeg",
            type: "custom",
            renderItem: function(params, api) {
              // 图形显示的行号下标，从0开始
              var categoryIndex = api.value(0) / 10;
              // 一行的宽度

              var height = 40;

              // x轴起始位置
              var startX = 0;
              // 对应到坐标系上的点[x,y]，0表示从y轴开始
              var point = api.coord([0, 0]);
              var x = point[0] + startX,
                y = point[1];
              // 圆半径
              var radius = 7;
              // 圆和文本的距离
              var dist = 8;
              var circleX = x + radius;
              var circleY = y + radius + (height - 2 * radius) / 2 + height * categoryIndex;
              var circle = {
                type: "circle",
                style: {
                  fill: colorMapping[api.value(0)]
                },
                shape: { cx: circleX, cy: circleY, r: radius }
              };
              var name = {
                type: "text",
                silent: true,
                style: {
                  text: statusMapping[api.value(0)],
                  x: circleX + radius + 0.5 * dist,
                  y: circleY,
                  textVerticalAlign: "middle",
                  font: "bolder 16px",
                  fill: colorMapping[api.value(0)]
                }
              };
              var hours = {
                type: "text",
                silent: true,
                style: {
                  text: api.value(1) + "h",
                  x: circleX + radius + 10 * dist,
                  y: circleY,
                  textVerticalAlign: "middle",
                  font: "bolder 16px",
                  fill: "#626366"
                }
              };
              var ratio = {
                type: "text",
                style: {
                  text: api.value(2) + "%",
                  x: circleX + radius + 16 * dist,
                  y: circleY,
                  textVerticalAlign: "middle",
                  font: "bolder 16px ",
                  fill: "#626366"
                }
              };
              // 返回一组图形
              return {
                type: "group",
                children: [circle, name, hours, ratio]
              };
            },
            encode: {
              x: [1, 2, 3, 4], //x轴起始位置，设备状态code，总时长，总时长占比
              y: 0
            },
            tooltip: {
              trigger: "none"
            },
            // data: this.statusRatioLableData[0]
            data: [{ value: [0, 0, 0] }, { value: [10, 0, 0] }, { value: [20, 0, 0] }, { value: [30, 0, 0] }, { value: [40, 0, 0] }]
          }
        ]
      };
      this.deviceStatusBlockStaitcChart.setOption(option);
    },
    initDeviceStatusView(data) {
      if (this.deviceStatusBlockChart != null) {
        this.deviceStatusBlockChart.clear();
        this.deviceStatusBlockChart.resize();
      }
      //获取x、y轴数据
      let colors = ["#A4A8AF", "#FFBE00", "#9AD681", "#409EFF", "#E86067"];
      let colorMapping = {
        0: colors[0],
        10: colors[1],
        20: colors[2],
        30: colors[3],
        40: colors[4]
      };
      let states = ["离线", "就绪", "运行", "停止", "报警停止"];

      let showData = [];
      if (data != null) {
        data.data.forEach((val, index) => {
          showData.push({
            itemStyle: { normal: { color: colorMapping[val.statusType] } },
            name: statusMapping[val.statusType],
            value: [val.deviceIndex, val.beginDate, val.endDate]
          });
        });
      }

      let device = [];
      if (data != null) {
        data.deviceCodes.forEach((val, index) => {
          device.push(val);
        });
      }

      var echarts = this.$Echarts;
      if (this.$refs["deviceStatusView"] == null) {
        return;
      }
      this.deviceStatusBlockChart = this.$Echarts.init(this.$refs["deviceStatusView"]);
      let vue = this;
      let option = {
        color: colors,
        tooltip: {
          //提示框
          formatter: function(params) {
            return params.name + ":" + params.value[1] + "~" + params.value[2];
          } //数据的值
        },

        //  dataZoom:{
        // 	type:'slider',
        // 	show : true,
        // 	yAxisIndex:[0],
        // 	left:'65%',
        // 	showDetail:false,
        // 	showDataShadow:false,
        // 	width:10,
        // 	maxValueSpan:5
        // },
        grid: [
          {
            left: "40",
            // right: this.totalDataViewWidth + "",
            right: "10%",
            top: "50",
            bottom: "0",
            containLabel: true
          }
        ],
        xAxis: [
          {
            type: "time",
            position: "bottom",
            gridIndex: 0,
            maxInterval: 8 * 60 * 60 * 1000,
            axisLine: {
              lineStyle: {
                type: "solid",
                width: 1,
                color: "#bbbbbb"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: "#626366",
              formatter: function(val, index) {
                let date = new Date(val);
                const Y = date.getFullYear() + "-";
                const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
                const D = date.getDate() < 10 ? `0${date.getDate()} ` : `${date.getDate()} `;
                const h = date.getHours() < 10 ? `0${date.getHours()}:` : `${date.getHours()}:`;
                const m = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
                return Y + M + D + h + m;
              },
              fontFamily: "PingFangSC-Regular",
              fontSize: "14"
            },

            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            inverse: true,
            data: device,
            gridIndex: 0,
            axisLabel: {
              formatter: function(val, index) {
                return val;
              },
              color: "#626366",
              fontFamily: "PingFangSC-Regular",
              fontSize: "14"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#bbbbbb"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            triggerEvent: {
              componentType: "",
              // 未格式化过的刻度值, 点击刻度标签有效
              value: "",
              // 坐标轴名称, 点击坐标轴名称有效
              name: ""
            }
          }
        ],
        series: [
          {
            type: "custom",
            xAxisIndex: 0,
            yAxisIndex: 0,

            renderItem: function(params, api) {
              // 对于 data 中的每个 dataItem，都会调用这个 renderItem 函数。
              // （但是注意，并不一定是按照 data 的顺序调用

              // 这里使用 api.value(0) 取出当前 dataItem 中第一个维度的数值。
              var categoryIndex = api.value(0);
              // 这里使用 api.coord(...) 将数值在当前坐标系中转换成为屏幕上的点的像素值。
              var startPoint = api.coord([api.value(1), categoryIndex]);
              var endPoint = api.coord([api.value(2), categoryIndex]);
              // 这里使用 api.size(...) 获得 Y 轴上数值范围为 1 的一段所对应的像素长度。
              //var height = api.size([0, 1])[1] * 0.2;
              var height = 20;

              // shape 属性描述了这个矩形的像素位置和大小。
              // 其中特殊得用到了 echarts.graphic.clipRectByRect，意思是，
              // 如果矩形超出了当前坐标系的包围盒，则剪裁这个矩形。
              // 如果矩形完全被剪掉，会返回 undefined.
              var rectShape = echarts.graphic.clipRectByRect(
                {
                  // 矩形的位置和大小。
                  x: startPoint[0],
                  y: startPoint[1] - height / 2,
                  width: endPoint[0] - startPoint[0],
                  height: height
                },
                {
                  // 当前坐标系的包围盒。
                  x: params.coordSys.x,
                  y: params.coordSys.y,
                  width: params.coordSys.width,
                  height: params.coordSys.height
                }
              );

              // 这里返回为这个 dataItem 构建的图形元素定义。
              return (
                rectShape && {
                  // 表示这个图形元素是矩形。还可以是 'circle', 'sector', 'polygon' 等等。
                  type: "rect",
                  shape: rectShape,
                  // 用 api.style(...) 得到默认的样式设置。这个样式设置包含了
                  // option 中 itemStyle 的配置和视觉映射得到的颜色。
                  style: api.style()
                }
              );
            },
            encode: {
              // data 中『维度1』和『维度2』对应到 X 轴
              x: [1, 2],
              // data 中『维度0』对应到 Y 轴
              y: 0,
              // 表示『维度2』和『维度3』要显示到 tooltip 中。
              tooltip: [2, 3]
            },
            // 表示给『维度2』和『维度3』分别取名，显示到 tooltip 中。
            dimensions: [null, "开始时间", "结束时间"],
            data: showData
          }
        ]
      };
      this.deviceStatusBlockChart.setOption(option);
      this.deviceStatusBlockStaitcChart.setOption({
        series: [
          {
            name: "pie",
            data: this.statusRatioData[0]
          },
          {
            name: "pieleg",
            data: this.statusRatioLableData[0]
          }
        ]
      });
      let this_ = this;
      this.deviceStatusBlockChart.on("click", "yAxis.category", function(o) {
        // this_.deviceStatusBlockChart.showLoading();
        this_.deviceStatusBlockChart.setOption({
          yAxis: {
            axisLabel: {
              textStyle: {
                color: function(value, index) {
                  return value === o.value ? "#409EFF" : "#626366";
                }
              }
            }
          }
        });
        this_.deviceStatusBlockStaitcChart.setOption({
          series: [
            {
              name: "pie",
              data: this_.statusRatioData[this_.deviceStatusBlockData.deviceCodes.indexOf(o.value)]
            },
            {
              name: "pieleg",
              data: this_.statusRatioLableData[this_.deviceStatusBlockData.deviceCodes.indexOf(o.value)]
            }
          ]
        });
      });
      // this.deviceStatusBlockChart.on("rendered",()=>{
      // 	this_.deviceStatusBlockChart.hideLoading();
      // })
      this.deviceStatusBlockChange = false;
    },
    startChange(ev) {
      this.searchForm.endDate = null;
      this.searchForm.defaultEnd = this.searchForm.startDate;
    },
    endChange() {
      if (this.searchForm.startDate > this.searchForm.endDate && this.searchForm.startDate != "") {
        this.searchForm.endDate = "";
        this.searchForm.startDate = "";
        this.$message.warning("结束时间不能小于开始时间");
      }
    }
  },
  watch: {
    workshopId: async function(newQuestion, oldQuestion) {
      this.clearPie();
      await this.loadDeviceStatusBlock();
      await this.loadDeviceOEEData();
    },
    deviceStatusBlockData: function(newQuestion, oldQuestion) {
      this.deviceStatusBlockChange = true;
    },
    deviceOEEViewData: function(newQuestion, oldQuestion) {
      this.initDeviceOEELine(newQuestion);
    }
  }
};
</script>

<style scoped>
.noData {
  width: 60%;
  height: 100%;
  position: absolute;
  line-height: 300px;
  text-align: center;
  font-weight: 100;
}
.dashbord {
  width: 100%;
  min-width: 1250px;
  position: absolute;
  background: #f6f7fa;
  right: 0;
  left: 0;
  top: 0;
  display: grid;
  gap: 20px;
  grid-template-rows: 80px 200px 350px 370px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas:
    "s s s s"
    "a b c d"
    "o o o o"
    "z z z z";
}
.panel {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  font-family: PingFangSC-Medium;
  color: #434343;
  font-weight: 600;
  position: relative;
}
.circle {
  text-align: center;
}
.circle /deep/ .el-progress__text {
  font-size: 30px !important;
  font-family: bebas;
}
.searchBar {
  grid-area: s;
  width: 100%;
  height: 80px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
}
#stopTime {
  display: flex;
  flex-wrap: nowrap;
  justify-content: stretch;
  margin: 30px 30px 0 20px;
  line-height: 78px;
}
.numP {
  height: 78px;
  width: 52px;
  font-size: 42px;
  font-family: bebas;
  background: #5584bf;
  margin-right: 20px;
  color: #ffffff;
  text-align: center;
}
#workShopGlobalChart {
  height: 100%;
}

.chartDiv {
  position: relative;
  height: 100%;
  border: solid 1px #dedfe6;
  margin-right: 11px;
}

.echart_title {
  position: absolute;
  top: 30px;
  left: 40px;
  height: 32px;
  line-height: 32px;
  color: #434343;
  font-family: PingFangSC-Medium;
  font-size: 16px;
}
::-webkit-scrollbar {
  width: 0px;
}
.echart_no_data {
  text-align: center;
  line-height: 360px;
  position: absolute;
  color: #999999;
  font-family: PingFangSC-Medium;
  font-size: 16px;
}
.oee_echart_div .echart_no_data {
  width: 800px;
  height: 360px;
}

.block_echart_div .echart_no_data {
  width: 1560px;
  height: 360px;
}
@media screen and (max-width: 1440px) and (min-width: 1367px) {
  .echart_no_data span {
    margin-right: 450px;
  }
  #workShopGlobalChart {
    height: 700px;
  }
}
@media screen and (max-width: 1280px) {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 180px !important;
  }
}

@media screen and (max-width: 1366px) {
  .echart_no_data span {
    margin-right: 532px;
  }
  #workShopGlobalChart {
    height: 800px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 180px !important;
  }
}
.panel /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>

<style></style>



// WEBPACK FOOTER //
// src/views/workshop/WorkShopGlobalChart.vue